// shared-types/src/common/Country.ts - Supported country codes and default config per country

export const SUPPORTED_COUNTRIES = ['UY', 'AR'] as const
export type SupportedCountryCode = (typeof SUPPORTED_COUNTRIES)[number]

export function isSupportedCountry(code: string): code is SupportedCountryCode {
    return SUPPORTED_COUNTRIES.includes(code as SupportedCountryCode)
}

export interface CountryDefaultBranchAddress {
    country: string
    department: string
    locality: string
    street: string
    number: string
    mapPosition: { lat: number; lng: number }
}

export interface CountryDefaultTax {
    name: string
    rate: number
    rateType: string
}

export interface CountryDefaultConfig {
    /** Display name for the country (e.g. for select options). */
    name: string
    timezone: string
    currency: string
    phoneCountryCode: string
    locale: string
    defaultBranchAddress: CountryDefaultBranchAddress
    defaultTaxes: CountryDefaultTax[]
}

/** Default configurations for enabled countries. Only countries with defaults are listed. */
export const COUNTRY_DEFAULTS: Record<string, CountryDefaultConfig> = {
    UY: {
        name: 'Uruguay',
        timezone: 'America/Montevideo',
        currency: 'UYU',
        phoneCountryCode: '+598',
        locale: 'es-UY',
        defaultBranchAddress: {
            country: 'Uruguay',
            department: 'Montevideo',
            locality: 'Centro',
            street: 'Calle 123',
            number: '123',
            mapPosition: { lat: -34.9211269, lng: -56.161656 },
        },
        defaultTaxes: [{ name: 'IVA', rate: 22, rateType: 'PERCENTAGE' }],
    },
    AR: {
        name: 'Argentina',
        timezone: 'America/Argentina/Buenos_Aires',
        currency: 'ARS',
        phoneCountryCode: '+54',
        locale: 'es-AR',
        defaultBranchAddress: {
            country: 'Argentina',
            department: 'Buenos Aires',
            locality: 'CABA',
            street: 'Calle ejemplo',
            number: '123',
            mapPosition: { lat: -34.6037, lng: -58.3816 },
        },
        defaultTaxes: [{ name: 'IVA', rate: 21, rateType: 'PERCENTAGE' }],
    },
}

export function getCountryDefaults(code: string): CountryDefaultConfig | null {
    if (!code || code.length !== 2) return null
    const key = code.toUpperCase()
    return COUNTRY_DEFAULTS[key] ?? null
}
